/**
 * @interface ProfilesState gives the data structure for the given user profile
 * the data, if its loading or the error
 */
export interface ProfilesState {
  data?: Profile[];
  loading?: boolean;
  error?: string;
}

/**
 * @interface Profile  represents a single user's profile. It contains all of the information about that user.
 */
export interface Profile {
  id: string;
  username?: string;
  playFabId: string;
  DisplayName?: string;
  avatarUrl?: string;
}

/**
 * It initializes the initial state for the profiles reducer.
 * The data array is initialized as an empty array, and the loading flag is set to false.
 */
const initialState: ProfilesState = {
  data: [],
  loading: false,
};

/**
 *
 * @param state
 * @param action
 * @returns the response given the specific case
 */
export function profilesReducer(state = initialState, action: any): any {
  switch (action.type) {
    /**
     *  Get Profile Info Reducer
     */
    case '[Profile] Loading Get Profile': {
      return { ...state, loading: true };
    }
    case '[Profile] Success Get Profile': {
      //Find the data and replace it
      const profile: Profile = action.payload;
      const idAlreadyInMemory = state.data.find(
        (stateProfile) => stateProfile.id === profile.id,
      );
      if (idAlreadyInMemory) {
        return { ...state, loading: false };
      } else {
        return { ...state, data: [...state.data, profile], loading: false };
      }
    }
    case '[Profile] Error Get Profile': {
      return { ...state, loading: false, error: action.error };
    }

    default:
      return state;
  }
}
